 ! function(e, t) {
  
    var o = "fixed-supported",
        n = e.document.createElement("div"),
        i = e.navigator.userAgent,
        c = e.document.documentElement;

    function d() {
        var i = "scrollTop" in e.document.body ? e.document.body.scrollTop : c.scrollTop;
        i !== t && i > 0 && e.document.body && (e.document.body.insertBefore(n, e.document.body.firstChild), n.getBoundingClientRect && 0 === n.getBoundingClientRect().top || (c.className = c.className.replace(o, "")), e.document.body.removeChild(n), e.removeEventListener ? e.removeEventListener("scroll", d, !1) : e.detachEvent("onscroll", d))
    }
    n.style.position = "fixed", n.style.top = 0, i.match(/Android 2\.[1256]/) && i.indexOf("AppleWebKit") > -1 && i.match(/Opera Mobi\/([0-9]+)/) && RegExp.$1 < 7458 && e.operamini && "[object OperaMini]" === {}.toString.call(e.operamini) && i.match(/Fennec\/([0-9]+)/) && RegExp.$1 < 6 || (c.className += " " + o, e.addEventListener ? e.addEventListener("scroll", d, !1) : e.attachEvent("onscroll", d)), e.FixedFixed = d
}(this);

// 1.Start of Eliran code : Add all this Variables to the head of the doc
var id = [];
var isBaseIn = false;
var isDockIn = false;
var numOfTops = 5;
var atLeastOneTop = false;
var is484 = false;
var numOfDocks = 0;
var numOfTopsmDocks = numOfDocks * numOfTops;
var docks = "";
var isPack = false;
// End of Eliran code

var SessionStorage = {
    getItem: function(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ')
                c = c.substring(1);
            if (c.indexOf(name) == 0)
                return c.substring(name.length, c.length);
        }
        return JSON.stringify(new Array());
    },
    setItem: function(cname, cvalue) {
        var d = new Date();
        d.setTime(d.getTime() + (2 * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
    }
};


(function($) {
    var re = /([^&=]+)=?([^&]*)/g;
    var decodeRE = /\+/g; // Regex for replacing addition symbol with a space
    var decode = function(str) {
        return decodeURIComponent(str.replace(decodeRE, " "));
    };
    $.parseParams = function(query) {
        var params = {},
            e;
        while (e = re.exec(query)) {
            var k = decode(e[1]),
                v = decode(e[2]);
            if (k.substring(k.length - 2) === '[]') {
                k = k.substring(0, k.length - 2);
                (params[k] || (params[k] = [])).push(v);
            } else
                params[k] = v;
        }
        return params;
    };
})(jQuery);

function checkAlreadyExist(items, pid) {
    var isfound = -1;
    for (var key in items) {
        if (items[key]['id'] == pid) {
            isfound = key;
            break;
        }
    }
    return isfound;
}

function storedata(pid, q, p, n, gim, catid) {
    if (typeof(Storage) !== "undefined") {
        var items = JSON.parse(SessionStorage.getItem("items"));
        if (items == null || items == '') {
            items = new Array();
        }
        var isexist = checkAlreadyExist(items, pid);
        if (isexist == -1) {
            items.push({
                id: pid,
                q: 1,
                p: p,
                n: n,
                gim: gim,
                catid: catid
            });
        } else {
            if (q == 0)
                delete items[isexist];
            items[isexist] = {
                id: pid,
                q: q,
                p: p,
                n: n,
                gim: gim,
                catid: catid
            };
        }
        SessionStorage.setItem("items", JSON.stringify(items));

    } else {
        alert("Your browser is old and is not supporting the functionality of the website.");
    }
}

$(document).ready(function() {

    $.ajax({
        url: "/cart.js",
        dataType: "json",
        success: function(data) {
            var items = new Array();

            var cart_items = data["items"];
            for (var key in cart_items) {
                if (cart_items[key].variant_title) {
                    var cf = ' - ' + cart_items[key].variant_title;
                } else {
                    var cf = '';
                }
                items.push({
                    id: cart_items[key].id,
                    q: cart_items[key].quantity,
                    p: (cart_items[key].price / 100),
                    n: cart_items[key].product_title + cf
                });
            }
            SessionStorage.setItem("items", JSON.stringify(items));
            displayit(JSON.parse(SessionStorage.getItem("items")));
            // 2. Eliran Code : Add this line, updates cartStatus
            cartStatus(JSON.parse(SessionStorage.getItem("items")));
            // End of Eliran Code
        }
    });


	var window_width = $( window ).width();

    function refreshitembox() {
        $('option').each(function() {
            var selector = $(this);
            var pid = selector.val();
            var items = JSON.parse(SessionStorage.getItem("items"));
            var isexist = checkAlreadyExist(items, pid);
          	
            if (isexist != -1) {
                var q = items[isexist]['q'];
                $(this).data("quantity", q);
            }
        });
    }
    refreshitembox();

    $(".qplus").on("click", function() {
      
        var quant = $(this).parent().find(".qquan");
        var qant = parseInt(quant.html());
        var gim = $(this).data("img-src");
        var catid = $(this).data("cat-id");

        quant.html(qant + 1);

        var cf = $(this).parent().find(".variant-title strong").text();

        if (cf) {
            cf = ' - ' + cf;
        } else {
            cf = '';
        }

        var name = $(this).closest('.p-item').find(".product-title").html().trim() + cf;
        var price = parseInt($(this).closest('.p-item').find(".pb-price").html().trim().substr(1));
      
        storedata($(this).data("id"), qant + 1, price, name, gim, catid);

        var items = JSON.parse(SessionStorage.getItem("items"));
        
        // 3. Eliran Code : Add this line, updates cartStatus
        cartStatus(items);
        // End of Eliran code
        displayit(items);
        updatecart();
    });
  	
  	function showRightbar(){
      $("#cartsum").css({
      	'right': '0px',
      })
      $("#cartsum").css({
        'right': '0px',
      })
      
      $("#overlay").css({'display': 'block',})
      $("body.template-cart").css({'overflow': 'hidden'})
    }	
  
  	function hiddenRightbar(){
      
      if(window_width > 768) {
       	 $("#cartsum").css({
              'right': '-450px'
        });
      }else {
       	 $("#cartsum").css({
              'right': '-100%'
        });
      }
      $("#overlay").css({'display': 'none'});
      $("body.template-cart").css({'overflow': 'initial'})
    }	
  
    $(".varidation-selection").on("click", function() {
      
        var button = $(this);
      
      	button.addClass("added");
      	button.html('Added to cart <span><img class="check-solid" src="https://cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/check-solid.svg?v=1591723521"></span>');
      
        var variantWrap = $(this).closest(".variant-wrap");
        var quant = variantWrap.find(".select-product-varidation option:selected");
        
        var gim = variantWrap.find(".hidden-value").data("img-src");
        var catid = variantWrap.find(".hidden-value").data("cat-id");
        var productId = parseInt(variantWrap.find(".select-product-varidation option:selected").val());
      	var qant = parseInt(quant.data("quantity"));

        quant.data("quantity", qant + 1);
        var cf = variantWrap.find(".select-product-varidation option:selected").data("variant-size");
		if (cf == 'Default Title') cf = false;
      
        if (cf) {
            cf = ' - ' + cf;
        } else {
            cf = '';
        }
        
        var name = variantWrap.find(".hidden-value").data("product-title") + cf;
        var price = parseInt(variantWrap.find(".hidden-value").data("product-price").substr(1));
        storedata(productId, qant + 1, price, name, gim, catid);
		
        var items = JSON.parse(SessionStorage.getItem("items"));
        // 3. Eliran Code : Add this line, updates cartStatus
        cartStatus(items);

        // End of Eliran code
        displayit(items);

        updatecart();

      
        setTimeout(function(){ 
          button.removeClass("added");
      	  button.text('$'+price+' - Add to Cart');
        }, 900);
      
        
    });



    $(".qminus").on("click", function() {
        var quant = $(this).parent().find(".qquan");
        var qant = parseInt(quant.html());
        var gim = $(this).data("img-src");
        var catid = $(this).data("cat-id");

        if (qant >= 1) {
            quant.html(qant - 1);
            var name = $(this).closest('.p-item').find(".product-title").html().trim();
            var price = parseInt($(this).closest('.p-item').find(".pb-price").html().trim().substr(1));
            storedata($(this).data("id"), qant - 1, price, name, gim, catid);
            var items = JSON.parse(SessionStorage.getItem("items"));
            // 4. Eliran Code : Add this line, updates cartStatus
            cartStatus(items);
            // End of Eliran code
            displayit(items);
            updatecart();
        }
    });
  
    $("#cartQty").on("click", function(e) {
      showRightbar();
      e.stopPropagation();
    })
    
    $("#gotocheckout").on("click", function(e) {
      showRightbar();
      e.stopPropagation();
    })

    $("#cartsum").on("click", ".view-cart", function() {
      hiddenRightbar();
    })
	
    $("#cartsum").click(function(e){
    	e.stopPropagation();
    });

    $(document).click(function(){
        hiddenRightbar();
    });
  
    
  
    $('select').on('change', function() {
      var selectText = $(this).closest('.variant-wrap').find('.selecttext');
      var buttonText = $(this).closest('.variant-wrap').find('button.varidation-selection')
      var selectedContent = $(this).find(":selected").text();
      var dataPrice = $(this).find(":selected").data("variant-price");
      selectText.html( selectedContent );
      buttonText.text(dataPrice + " - Add to Cart");
      var dataValue = $(this).find(":selected").data("value");
      $(this).closest('.variant-wrap').find("input.hidden-value").data("product-price", dataPrice);
    });
  
  
  	$(".selecttext").click(function() {
		$(this).closest('.variant-wrap').find('.select-product-varidation').trigger('click');
    });

    $(".product-rows").on("click", ".qplus", function() {
        var quant = $(this).parent().find(".qquan");
        var qant = parseInt(quant.html());
        var gim = $(this).data("img-src");
        var catid = $(this).data("cat-id");

        quant.html(qant + 1);
        var name = $(this).parent().parent().parent().find(".product-title").html().trim();
        var price = parseInt($(this).parent().parent().parent().find(".pb-price").html().trim().substr(1));
        storedata($(this).data("id"), qant + 1, price, name, gim, catid);
        var items = JSON.parse(SessionStorage.getItem("items"));
        // 5. Eliran Code : Add this line, updates cartStatus
        cartStatus(items);
        // End of eliran code
        displayit(items);
        updatecart();
    });
    $(".product-rows").on("click", ".qminus", function() {
        var quant = $(this).parent().find(".qquan");
        var qant = parseInt(quant.html());
        var gim = $(this).data("img-src");
        var catid = $(this).data("cat-id");

        if (qant >= 1) {
            quant.html(qant - 1);
            var name = $(this).parent().parent().parent().find(".product-title").html().trim();
            var price = parseInt($(this).parent().parent().parent().find(".pb-price").html().trim().substr(1));
            storedata($(this).data("id"), qant - 1, price, name, gim, catid);
            if (qant - 1 == 0) {
                $(this).parent().parent().parent().remove();
            }
            var items = JSON.parse(SessionStorage.getItem("items"));
            // 6. Eliran Code : Add this line, updates cartStatus
            cartStatus(items);
            // End of code
            displayit(items);
            updatecart();
        }
    });

    var cats = new Array();

    function is_cat_already_exist(pid) {
        var isfound = -1;
        for (key in cats) {
            if (cats[key]['id'] == pid) {
                isfound = key;
                break;
            }
        }
        return isfound;
    }
    // 7. Start of Eliran code : Add this code to the file, it includes the displayit() function so replace it until the endofcode comment.
    var topIds = [
        
        
      	33893992530051,
        33287211090051,
      	33287211122819,
      	33287211155587,
      	33893993283715,
      	33893993447555,
      	33893764235395,
		33287257325699,
      	33287257358467,
      	33287257391235,
      	33893769150595,
      	33893769838723,
      	33893996920963,
      	33287232913539,
      	33287232946307,
      	33287232979075,
      	33893997281411,
      	33893997412483,
      	33893998461059,
      	33286619955331, 
      	33286619988099, 
      	33286620020867,
      	33893998592131,
      	33893998788739,
      	33894057574531,
      	33287263223939,
      	33287263289475,
      	33287263355011,
      	33894058197123,
      	33894058721411,
      	33894092079235,
      	33287274659971,
      	33287274692739,
      	33287274725507,
      	33894093095043,
      	33894093979779,
      	33894096666755,
      	33287163969667,
      	33287164002435,
      	33287164035203,
      	33894096863363,
      	33894099386499,
      	33894137725059,
      	33287187693699,
      	33287187726467,
      	33287187759235,
      	33894138544259,
      	33894138740867,
      	33894154010755,
      	33287224524931,
      	33287224590467,
      	33287224623235,
      	33894156927107,
      	33894157451395,
      	33894165971075,
      	33287239434371,
      	33287239467139,
      	33287239499907,
      	33894166659203,
      	33894168232067,
      	34192342712451,
		34192342745219,
      	34192342777987, 
		34192342810755,
     	34192342843523,
      	34192342876291,
		34193503289475,
		34193503322243,
      	34193503355011,
      	34193503387779,
      	34193503420547,
      	34193503453315
       ];
   


    function cartStatus(items) {
        numOfTopsIn = 0;
        isBaseIn = false;
        isDockIn = false;
        atLeastOneTop = false;
        isPopular = false;
        numOfDocks = 0;
      	isMinimetalIn = false;
      	isfullCollectionIn = false;
        docks = "";
        isPack = false;
        for (var n in items) {
            if (items[n] && items[n].q > 0) {
                var c = items[n].id;
                for (var i = 0; i < topIds.length; i++) {
                    if (c === 33287187726467) {
                        isPopular = true;
                    }
                    if (c === topIds[i]) {
                        var q = items[n].q;
                        var tot = 0;
                        tot = tot + q;
                        numOfTopsIn += tot;
                    };
                }
            }
        }
        for (var n in items) {
            if (items[n] && items[n].q > 0) {
                var c = items[n].id;
                if (c === 33263433875587 || c === 33263407857795 || c === 33263399633027) {
                    isBaseIn = true;
                }
                if (c === 33263450456195 || c === 33263438823555 || c ===34193534812291) {
                    isDockIn = true;
                    numOfDocks += items[n].q;
                    if (numOfDocks > 1) {
                        docks = "s"
                    }
                    numOfTopsmDocks = numOfDocks * 5;
                    numOfTops = numOfTopsmDocks;
                    numOfTops -= numOfTopsIn;
                    if (numOfTops < 0) {
                        numOfTops = 0;
                    }
                }
                if (c === 33894075465859 || c === 33286972866691 || c === 33286972899459 || c === 33286972932227 || c === 33894075793539 || c === 33894076481667 || c === c=== 33894081134723 || c === 33286953533571 || c === 33286953566339 || c === 33286953599107 || c === 33894087196803 || c === 33894087950467 || c === 33893764235395 || c === 33287257325699 || c === 33287257358467 || c === 33287257391235 || c === 33893769150595 || c === 33893769838723) {
                    isPack = true;
                    docks = "s";
                }
              	if (c=== 33894075465859 || c === 33286972866691 || c === 33286972899459 || c === 33286972932227 || c === 33894075793539 || c === 33894076481667 ) {
                    isfullCollectionIn = true;
                }
              	if (c=== 33894081134723 || c === 33286953533571 || c === 33286953566339 || c === 33286953599107 || c === 33894087196803 || c === 33894087950467) {
                    isMinimetalIn = true;
                }
            }
        }
    }



  
   
  
    function displayit(data) {
        var html = '<div class="clearfix-wrapper">';
        var quan = "";
        var total = sum = 0;
        var cart = "";
        var ctcount = 0;

        for (var n in data) {
            if (data[n] && data[n].q > 0) {
                html += '<div class="clearfix"><div class="col-sm-6 product-title">' + data[n].n + '</div>';
                html += '<div class="col-sm-2 pb-price">$' + data[n].p + '</div>';
                html += '<div class="col-sm-2"><div class="quantity">';
                html += '<span class="qminus" data-id="' + data[n].id + '" data-img-src="' + data[n].gim + '" data-cat-id="' + data[n].catid + '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"/></svg></span>';
                html += '<span class="qquan">' + data[n].q + '</span>';
                html += '<span class="qplus" data-id="' + data[n].id + '" data-img-src="' + data[n].gim + '" data-cat-id="' + data[n].catid + '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"/></svg></span>';
                html += '</div><input type="hidden" id="updates_' + data[n].id + '" name="updates[]"value="' + data[n].q + '" pattern="[0-9]*" aria-label="quantity" data-id=""  class="js-qty__num"></div>';
                html += '<div class="col-sm-2"><a data-id="' + data[n].id + '" class="removeit" href="javascript:void(0);">Remove</a></div></div>';
                total += data[n].p * data[n].q;
                sum += parseInt(data[n].q);
                cart += '<div class="cart">';
                cart += '</div>';
                ctcount += parseInt(data[n].q);
            }

            refreshitembox();
        }
      	


        jQuery('#cartQty span').text(ctcount);

        if (sum > 0) {
            $("#gotocheckout").addClass("active");
            $("#cartQty").show();
        } else {
            $("#gotocheckout").removeClass("active");
            $("#cartQty").hide();
        }
        var text = $(".total-price").text();
		html += '<div class="button-group"><a class="pay-now" href="/checkout/">Payment(' + (window.SHOP_CURRENCY || 'USD') + ' ' + total + ')</a><a class="view-cart">Return to Store <span><img src="https://cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/return-arrow.svg?v=1591655795" /></span></a></div></div>';

        var shipping = 69 - total;

        if (total < 69 && sum <= 0) {
            // $(".freeshipingtext").css("display", "none");
            $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss1'><a class='addtb' href='#'><img class='imgside topandbase' src='//cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/satandt_150x.png?v=108208727663188183691603745827' alt='Ring'></a> For only <strong>$46 </strong> <br/><a class='addtb' href='#'><u>Add popular stainless stand</u></a></span>");
        } else if (total < 1) {
            // $(".freeshipingtext").css("display", "none");  
           if (!isBaseIn) {
              
                $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss2'><a class='addas' href='#'><img class='imgside topandbase' src='//cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/satandt_150x.png?v=108208727663188183691603745827' alt='Ring'></a> For only <strong>$46 </strong> <br/><a class='addtb' href='#'><u>Add popular stainless stand</u></a></span>");
              if(isDockIn) {
                $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss2'><a class='tmr-block'><img class='imgbase' src='//cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/bzt_150x.png?v=61040053786779491971603745876' alt='ring'></a> For only <strong>$96 </strong>more <br/><a class='tmr-block'>Consider adding our most popular titanium ring!</a></span>");
              }
            } else if (!isPopular) {
                jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss17'><a class='tmr-block'><img class='imgside' src='//cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/titanium_150x.png?v=132019489852017364861603745864'; alt='Ring'> For only <strong>$96 </strong>more <br/><a class='tmr-block'>Consider adding our most popular titanium ring</a></span>");
            } else {
                $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss4'> Spend <strong>$" + shipping + " more</strong> for free shipping<br/></span>");
            }
        } else if (total >= 1) {

        jQuery(".cart_quantity .cart_empty").empty();
        jQuery(".freeshipingtext").css("display", "block");
        if (!isBaseIn) {

        if (!isDockIn){
            if (numOfTopsIn > 2) {
                jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss5'><a class='adds' href='#'><img class='imgbase' src='//cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/satandt_150x.png?v=108208727663188183691603745827'; alt='Stand'>Display with <strong>ingotdock</strong><br/><u>Click to add Dock!</u></a></span>");
            }else{
                jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss5'><a class='adds' href='#'><img class='imgbase' src='//cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/satandt_150x.png?v=108208727663188183691603745827'; alt='Stand'></a> For only <strong>$46 </strong> <br/><a class='addtb' href='#'><u>Add popular stainless stand</u></a></span>");
            }
        } else {
            if (numOfTopsIn > 0) {
                 jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss13'><a class='addt' href='#'><img class='imgside' src='//cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/titanium_150x.png?v=132019489852017364861603745864'; alt='ring'></a>Your display dock can hold <strong>" + (numOfTops) + " more rings</strong><br></span>");
                if (numOfTops === 0) {
                    jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss16'></span>");
                }
            } else {
                jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss13'><a class='tmr-block'><img class='imgside' src='//cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/titanium_150x.png?v=132019489852017364861603745864'; alt='ring'></a>Your dock can hold <strong>" + (numOfTops) + " more rings</strong><br><a class='tmr-block'>Consider adding most popular titanium ring</a></span>");
            }
        }
        if (!isDockIn && isfullCollectionIn && numOfTopsIn === 0) {

            jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss16'></span>");
        }
        if (!isDockIn && isMinimetalIn && numOfTopsIn === 0) {
		jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss16'></span>");
          //  jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss17'><a class='zmr-block'><img class='imgside' src='//cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/bzt_150x.png?v=61040053786779491971603745876'; alt='ring'></a> Black Zirconium is the most elegant material. <br/><a class='zmr-block'>Consider adding Ziconium ring</a></span>");
        }
    } else {

    if (!isDockIn && numOfTopsIn > 2 && !isPack) {
    jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss6'><a class='addd' href='#'><img class='imgside' src='//cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/Dockt_500x.png?v=70486916377903257901603745817'; alt='Dock'>Display with <strong>ingotdock</strong><br><u>Click to add Dock</u></a></span>");
    } 
    else if (isPack && numOfTopsIn > 2 && !isDockIn) {
    jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss7'><a class='addd' href='#'><img class='imgside' src='//cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/Dockt_500x.png?v=70486916377903257901603745817'; alt='Dock'>Display with <strong>ingotdock</strong><br><u>Click to add Dock</u></a></span>");
    } 
    else if ((numOfTopsIn - numOfTopsmDocks) >= 3) {
    jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss8'><a class='addd' href='#'><img class='imgside' src='//cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/Dockt_500x.png?v=70486916377903257901603745817'; alt='Dock'>Perhaps another <strong>ingotdock</strong><br><u>Click to add another Dock</u></a></span>");
    } 
    else if (isDockIn && numOfTops <= 5 && atLeastOneTop && !isPopular && !isPack) {
    jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss9'><a class='addt' href='#'><img class='imgside' src='//cdn.shopify.com/s/files/1/1020/2329/t/43/assets/tinobg_small.png?v=257592405185219245'; alt='ring'></a>Your dock" + docks + " can hold <strong>" + (numOfTops) + " more rings</strong><br><a class='addt' href='#'>Consider adding our most popular titanium ring</a></span>");
        if (numOfTops === 0) {
        jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss10'><img class='imgside' src='//cdn.shopify.com/s/files/1/1020/2329/t/43/assets/tinobg_small.png?v=257592405185219245'; alt='ring'><strong>Titanium</strong> is the worldÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢s favorite ring<br/><a class='addt' href='#'>Consider adding our most popular titanium ring</a></span>");
        }
    } else if (isDockIn && numOfTops <= 5 && atLeastOneTop) {
        jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss11'>Your display dock" + docks + " can hold <strong>" + (numOfTops) + " more rings</strong></span>");
        if (numOfTops === 0) {
        jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss12'></span>");
        }
    } else if (isDockIn && !isPopular && !isPack) {
        jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss13'><a class='addt' href='#'><img class='imgside' src='//cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/titanium_150x.png?v=132019489852017364861603745864'; alt='ring'></a>Your display dock can hold <strong>" + (numOfTops) + " more rings</strong><br></span>");
        if (numOfTops === 0) {
            jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss16'></span>");
        }
    } else if (isDockIn) {
        jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss15'>Your display dock" + docks + " can hold <strong>" + (numOfTops) + " more rings</strong></span>");
        if (numOfTops === 0) {
        jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss16'></span>");
        }
    } else if (!isPopular && !isPack) {
        jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss17'><a class='tmr-block'><img class='imgside' src='//cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/bzt_150x.png?v=61040053786779491971603745876'; alt='ring'></a> For only <strong>$276 </strong>more <br/><a class='tmr-block'><u>Consider adding elegant Black Zirconium ring</u></a></span>");
        if (numOfTopsIn > 0) {
            jQuery(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty ss17'><a class='zmr-block'><img class='imgside' src='//cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/bzt_150x.png?v=61040053786779491971603745876'; alt='ring'> Zirconium is the most elegant material. <br/><a class='zmr-block'>Consider adding Black Zirconium ring</span>");
        }
    }
}
        }
    else {
    jQuery(".cart_quantity .cart_empty").empty();
    jQuery(".freeshipingtext").css("display", "block");
    }
    jQuery(".product-rows").html(html);
    jQuery(".payment-title > .total-price").html("$" + total);
    }

            
    // End Of Code! Importent! Replace this code with the displayit() function in the original file!

    var x;


    if (typeof(Storage) !== "undefined") {
        var items = JSON.parse(SessionStorage.getItem("items"));
        if (items == null || items == '') {
            $(".product-rows").html("");
        } else {
            // 8. Eliran Code : Add this line, updates cartStatus
            cartStatus(items);
            // End of code
            displayit(items);
        }
    }



    $(".product-rows").on("click", '.removeit', function(e) {
      
        e.preventDefault();
        e.stopPropagation();
      	var subtotal = 0;
        var items = JSON.parse(SessionStorage.getItem("items"));
        var pid = $(this).data("id");
        var isexist = checkAlreadyExist(items, pid);
      
        if (isexist != -1) {
            
            var item = items[isexist];
  
            items[isexist] = ({
                id: pid,
                q: 0,
                p: item.p,
                n: item.n,
                gim: item.gim,
                catid: item.catid
            });

        }
      
        SessionStorage.setItem("items", JSON.stringify(items));
        var items = JSON.parse(SessionStorage.getItem("items"));
        if(checkTotalNumber(items) == 0) {
			hiddenRightbar();
        }
        refreshitembox();
        updatecart();
        // 9. Eliran Code : Add this line, updates cartStatus
        cartStatus(items);
        // End of code
        displayit(items);
    });

      function checkTotalNumber(items) {
        var subtotal = 0;
       	$.each( items, function( key, value ) {
          subtotal += value.q;
        }); 
        return subtotal;
      }

    function refresh() {
        var items = JSON.parse(SessionStorage.getItem("items"));
        var qu = 0;
        for (key in items) {
            if (!items[key])
                continue;
            qu += items[key].q;
        }
        if (qu > 0) {
            $("#gotocheckout").addClass("active");
            $("#cartQty").show();
        } else {
            $("#gotocheckout").removeClass("active");
            $("#cartQty").hide();
        }
    }
    refresh();

    $("#addBase").on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33263407857795
        };
        for (key in prods) {
            $("#vi-" + prods[key]).attr({"selected": true});
          	$("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'PROMO_basebanner',
            'name': 'Add Base Banner',
            'creative': 'text',
            'position': 'body'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Base Banner');




    });


    $("#addDock").on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33263450456195
        };
        for (key in prods) {
            $("#vi-" + prods[key]).attr({"selected": true});
          	$("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'PROMO_dockbanner',
            'name': 'Add Dock Banner',
            'creative': 'text',
            'position': 'body'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Dock Banner');




    });


    $('body').on('click', '.addb', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33263407857795
        };
        for (key in prods) {
            $("#vi-" + prods[key]).attr({"selected": true});
          	$("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'PROMO_base',
            'name': 'Add Base',
            'creative': 'textandimage',
            'position': 'cart'
        });
	
        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Base');
    });


    $('body').on('click', '.addtb', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var prods = {
            0: 33263399633027
        };
        for (key in prods) {
            $("#vi-" + prods[key]).attr({"selected": true});
          	$("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
      	
        ga('ec:addPromo', {
            'id': 'PROMO_baseandtop',
            'name': 'Add Base and Top',
            'creative': 'textandimage',
            'position': 'cart'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Base and Top');


    });


    $('body').on('click', '.zmr', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33287239467139
        };
        for (key in prods) {
            $("#vi-" + prods[key]).attr({"selected": true});
          	$("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'PROMO_zircorium',
            'name': 'Add Zicronium Medium Ring',
            'creative': 'textandimage',
            'position': 'cart'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Zicronium Medium Ring');

    });


    $('body').on('click', '.addd', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33263450456195
        };
        for (key in prods) {
            $("#vi-" + prods[key]).attr({"selected": true});
          	$("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'PROMO_dock',
            'name': 'Add Dock',
            'creative': 'textandimage',
            'position': 'cart'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Dock');
    });

    $('body').on('click', '.tmr', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33287187726467
        };
        for (key in prods) {
            $("#vi-" + prods[key]).attr({"selected": true});
          	$("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'promo_titanium_medium_ring',
            'name': 'Add Titanium Ring',
            'creative': 'textandimage',
            'position': 'cart'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Titanium Ring');
    });


    $('body').on('click', '.adds', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33263399633027
        };
        for (key in prods) {
            $("#vi-" + prods[key]).attr({"selected": true});
          	$("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'PROMO_stand',
            'name': 'Add Stand',
            'creative': 'textandimage',
            'position': 'cart'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Stand');
    });

    $('body').on('click', '.addas', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33263407857795
        };
        
        for (key in prods) {
            $("#vi-" + prods[key]).attr({"selected": true});
          	$("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'PROMO_stand',
            'name': 'Add Aluminium Stand',
            'creative': 'textandimage',
            'position': 'cart'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Aluminium Stand');
    });


    $('body').on('click', '.addtr', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33287187726467
        };
        for (key in prods) {
            $("#vi-" + prods[key]).find(".qplus").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'PROMO_ring',
            'name': 'Add Titanium Ring',
            'creative': 'textandimage',
            'position': 'cart'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Titanium Ring');
    });




    var ispost = false;


    var total = 0;
    var sum = 0;
    var items = JSON.parse(SessionStorage.getItem("items"));

    for (n in items) {
        if (items[n] && items[n].q > 0) {
            total += items[n].p * items[n].q;
            sum += parseInt(items[n].q);
        }
    }

    if (parseInt(total) == 0) {
        $(".cart_quanity1").html('');
        $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'>Your cart is empty. <strong>Spend $69</strong> for free shipping<br/><a class='allproductss' href='#'>Add our Starter Pack!</a></span>");
    }
});



$("#giftcheck").click(function() {

    ga('ec:addPromo', {
        'id': 'PROMO_enterstore',
        'name': 'Enter Store',
        'creative': 'menu',
        'position': 'cart'
    });

    ga('ec:setAction', 'promo_click');
    ga('send', 'event', 'Internal Promotions', 'click', 'Enter Store');



});

var xhr;

function updatecart() {
    var items = JSON.parse(SessionStorage.getItem("items"));
    var parmas = {};
    for (key in items) {
        parmas[items[key]['id']] = items[key]['q'];
    }
    if (xhr && xhr.readystate != 4) {
        xhr.abort();
    }
    xhr = jQuery.ajax({
        url: '/cart/update.js',
        type: "post",
        dataType: "json",
        data: {
            updates: parmas
        },
        success: function(data) {}
    });
}
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};



discount = getUrlParameter('discount');
if (discount != null) {
    if (typeof(Storage) !== "undefined") {
        SessionStorage.setItem("discount", discount);
    }
}



if (SessionStorage.getItem("discount") !== null) {

    var discount = SessionStorage.getItem("discount");

    if (discount != '[]') {
        $('#gotocheckout').each(function() {
            this.href += '?discount=' + discount;
        })
    }

    if ($("#discount_input").length && discount != '[]') {

        $("#discount_input").val(SessionStorage.getItem("discount"));
        document.cookie = "discount=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";

    } else {
        $("#discount_input").remove();
    }
}


$(document).ready(function($) {


    if ($("#breakPoint").length) {
        var doclength = $("#breakPoint").offset().top;
        var winheight = $(window).height();
        var wintop = $(window).scrollTop();
    }

    $(window).resize(function() {
        if ($("#breakPoint").length) {
            doclength = $("#breakPoint").offset().top;
            winheight = $(window).height();
            wintop = $(window).scrollTop();
        }
    });
    $(window).on('load', function() {
        if ($("#breakPoint").length) {
            doclength = $("#breakPoint").offset().top;
            $(window).on("scroll", function() {
                winheight = $(window).height();
                wintop = $(window).scrollTop();

                if ((wintop + winheight - 108) >= doclength) {
                    if ($(".cart-area").hasClass("stick") == false) {
                        $("#breakPoint").css({
                            "padding-bottom": 0
                        });
                        $(".cart-area").addClass("stick");
                        $(".copyright").show();
                    }
                } else {
                    if ($(".cart-area").hasClass("stick") == true) {
                        $("#breakPoint").css({
                            "padding-bottom": 150
                        });
                        $(".cart-area").removeClass("stick");
                        $(".copyright").hide();
                    }
                }
            });
        }
    });
});

$(document).ready(function($) {
  
    $(".weight").click(function() {
        $("p", this).toggle(300);
        $("i", this).toggleClass('fa-chevron-up fa-chevron-down');
        $(".weight").toggleClass('active');
    });
  

});





jQuery(document).ready(function() {
    let searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('open_ring_sizer')) {
        $.magnificPopup.open({
            items: {
                src: '#ring-sizer'
            },
            type: 'inline',
            callbacks: {
              close: function(){
                gtag('event', 'Ring Sizer Popup', {'event_category': 'Ring Sizer', 'event_label': 'store page ring sizer'}); console.log("Ring Sizer Popup");
                mixpanel.track("Ring Sizer Popup", {
                        "Action": "Ring Sizer Popup",
                        "Type": "Ring Sizer",
                        "Label": "Store Page Ring Sizer Popup"
                });
              }
            }
        });
    }
})






$("#prints").on("click", function(e) {
     
        gtag('event', 'Print Sizer', {'event_category': 'Print', 'event_label': 'open print ring sizer'}); console.log("Print Sizer");
                mixpanel.track("Popup", {
                        "Action": "Print Sizer",
                        "Type": "Print",
                        "Label": "Open Print Ring Sizer"

  });


    });
